import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-card-ai-menu',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatCardModule, MatIconModule, TranslocoPipe],
    templateUrl: './card-ai-menu.component.html',
    styleUrl: './card-ai-menu.component.scss',
})
export class CardAiMenuComponent {
    @Input() isCollapsed = false;
    @Output() toggleAi = new EventEmitter<void>();

    public openAi(event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        this.toggleAi.emit();
    }
}
